import SelectedTipMenuWidget from "./SelecedTipMenuWidget";
import HomeStats from "./HomeStats";
import TopDenyCard from "./TopDenyCard";
import TopTippersCard from "./TopTippersCard";
import BankedTipsWidget from "./widgets/BankedTipsWidget";
import CumCounterUpdate from "./widgets/CumCounterUpdate";
import DenyStatusUpdate from "./widgets/DenyStatusUpdate";
import OnlineStatusUpdate from "./widgets/OnlineStatusUpdate";

// The broadcaster's home: the numbers up top, then what's owed, who's
// tipping, the live menus and the show controls. One column on a phone,
// two from tablet width, three on a wide screen.
const Dashboard = () => (
  <div className="bg-base-200 min-h-full p-2 sm:p-4 flex flex-col gap-4">
    <HomeStats />
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 items-start">
      <BankedTipsWidget />
      <TopTippersCard />
      <SelectedTipMenuWidget />
      <OnlineStatusUpdate />
      <CumCounterUpdate />
      <DenyStatusUpdate />
      <TopDenyCard />
    </div>
  </div>
);

export default Dashboard;
